module.exports = __webpack_public_path__ + "static/media/logo_white.afaab054.svg";